import { useEffect } from 'react';
import {
  DEFAULT_COLOR_SCHEME,
  DEFAULT_TAB_FAVICON,
  DEFAULT_TAB_TITLE,
} from '@distribusion/portal-lib/constants';
import { BannerLocationEnum, useUserSettingsStore } from '@distribusion/portal-lib/user-settings';
import { addHashToColor, setDocumentIcon, setDocumentTitle } from '@distribusion/portal-lib/utils';
import ConfigProvider from 'antd/es/config-provider';

import { useFirstPartnerPreferencesIfExist } from './api/preferences';

interface SettingsControllerProps {
  children: React.ReactElement;
}

export const SettingsController = ({ children }: SettingsControllerProps) => {
  const { data } = useFirstPartnerPreferencesIfExist();
  const {
    setPrimaryColor,
    setCommunicationBannerText,
    setCommunicationBannerLocation,
    setDisplayCommunicationBanner,
  } = useUserSettingsStore();

  useEffect(() => {
    setDisplayCommunicationBanner(data?.display_communication_banner || false);
    setCommunicationBannerLocation(
      data?.communication_banner_location || BannerLocationEnum.MAIN_PAGE,
    );
    setCommunicationBannerText(data?.communication_banner_text || '');
    const color =
      (data?.color && addHashToColor(data?.color)) || DEFAULT_COLOR_SCHEME.PRIMARY_COLOR;
    setPrimaryColor(color);
    ConfigProvider.config({
      theme: {
        primaryColor: color,
      },
    });
    setDocumentTitle(data?.tab_title || DEFAULT_TAB_TITLE);
    setDocumentIcon(data?.tab_favicon_url || DEFAULT_TAB_FAVICON);
  }, [
    data,
    setCommunicationBannerLocation,
    setCommunicationBannerText,
    setDisplayCommunicationBanner,
    setPrimaryColor,
  ]);

  return children;
};
